export default __webpack_public_path__ + "static/media/invoiceViewSelected.be0a93eb.svg";